<template>
  <div class="app-container">
    <el-card class="box-card">
      <el-descriptions title="" :column="7" :colon="false">
        <el-descriptions-item label="统计于：">{{exceptionObj.time}}</el-descriptions-item>
        <el-descriptions-item label="订单："><span class="c-danger">{{exceptionObj.allOrderCount}}</span>个推送失败</el-descriptions-item>
        <el-descriptions-item label="收款单："><span class="c-danger">{{exceptionObj.shoukuandanCount}}</span>个推送失败</el-descriptions-item>
        <el-descriptions-item label="付款单："><span class="c-danger">{{exceptionObj.fukuanCount}}</span>个推送失败</el-descriptions-item>
        <el-descriptions-item label="退款单："><span class="c-danger">{{exceptionObj.tuikuanCount}}</span>个推送失败</el-descriptions-item>
        <el-descriptions-item label="用户信息："><span class="c-danger">{{exceptionObj.yonghuCount}}</span>个推送失败</el-descriptions-item>
        <!-- <el-descriptions-item label=""><el-button type="primary" @click="handleQuery" size="mini">重新统计</el-button></el-descriptions-item> -->
      </el-descriptions>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="推送类型：" prop="name">
            <el-select v-model="query.authority" placeholder="请选择" clearable size="small">
              <el-option label="新增用户" :value="1"></el-option>
              <el-option label="修改用户" :value="2"></el-option>
              <el-option label="升级身份" :value="2"></el-option>
              <el-option label="降级身份" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号：" prop="deptName">
            <el-input v-model="query.deptName" placeholder="请输入手机号" clearable size="small" />
          </el-form-item>
          <el-form-item label="推送状态：">
            <el-select v-model="query.deptStatus" placeholder="请选择" clearable size="small">
              <el-option label="推送成功" :value="1"></el-option>
              <el-option label="推送失败" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="推送时间范围：">
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <!-- <el-button type="primary" @click="handlePush(1,'')" size="mini">批量推送</el-button> -->
            <!-- <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button> -->
          </el-form-item>
        </el-form>
      </div>
      <el-divider></el-divider>
      <el-table v-loading="listLoading" :data="list " @selection-change="selectionChange">
        <el-table-column type="selection" width="50" />
        <el-table-column label="推送类型" prop="deptName" align="center" fixed>
        </el-table-column>
        <el-table-column label="用户名称" prop="deptName" align="center" fixed>
        </el-table-column>
        <el-table-column label="手机号" prop="deptName" align="center">
        </el-table-column>
        <el-table-column label="身份" prop="deptName" align="center">
        </el-table-column>
        <el-table-column label="添加单据池时间" prop="operatedTime" align="center" sortable width="200">
        </el-table-column>
        <el-table-column label="推送成功时间" prop="operatedTime" align="center" sortable width="200">
        </el-table-column>
        <el-table-column label="推送状态" prop="deptStatus" align="center" width="150">
          <template slot-scope="{row}">
            <el-button type="success" plain size="mini">成功按钮</el-button>
            <!-- <el-button type="danger" plain size="mini">危险按钮</el-button> -->
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="250">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleShow(row)">详情</el-button>
            <!-- <el-button type="text" @click="handlePush(0,row)">推送用户信息</el-button> -->
            <el-button type="text" @click="handleDel(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <order-show ref="orderShow" @created="doQueryList({})" />
  </div>
</template>

<script>
import orderShow from './show'
import sysDeptApi from '@/api/sys/sysDept'
import Pagination from '@/components/Pagination'
import homeStatisticsApi from '@/api/home'
import { Subtr, formatDateStr } from '@/utils/index'
export default {
  components: {
    Pagination,
    orderShow
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      selectItems: [],
      exceptionObj: {}
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
    this.getException()
  },
  methods: {
    getException() {
      homeStatisticsApi.getHomeException().then(res => {
        let { dinghuoCount, miaoshaCount, jifenCount } = res.data;
        let count = Subtr(Subtr(dinghuoCount, -miaoshaCount), -jifenCount)
        res.data.allOrderCount = count
        res.data.time = formatDateStr(new Date())
        this.exceptionObj = res.data;
      })
    },
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 10,
        // canLookGoodsPrice: 1,
        // canStudyCourse: 1
      }
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 执行列表查询
     */
    doQueryList({
      pageNo,
      pageSize
    }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      let query = {
        ...this.query
      }
      // if (this.query.authority) {
      //   if(this.query.authority == 1){
      //     query.canLookGoodsPrice = 1
      //   }else{
      //     delete query.canLookGoodsPrice
      //   }
      //   if(this.query.authority == 2){
      //     query.canStudyCourse = 1
      //   }else{
      //     delete query.canStudyCourse
      //   }
      // }
      // delete query.authority
      // this.query.displayPosition=this.activeName
      this.listLoading = true
      return sysDeptApi.fetchList(query)
        .then(({
          data
        }) => {
          console.log("data: ", data);
          this.list = data.list
          this.total = data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    // 推送
    handlePush(type, row) {

    },
    // 删除
    handleDel(row) {

    },
    /**
     * 打开详情表单
     */
    handleShow() {
      this.$refs.orderShow.handleCreate()
    }
  }
}
</script>
<style scoped lang="scss">
::v-deep .el-button--success.is-plain:focus,
.el-button--success.is-plain:hover {
  color: #67c23a;
  background: #f0f9eb;
  border-color: #c2e7b0;
}
</style>
